module.exports = __webpack_public_path__ + "img/gp.fa4cab3e.svg";